<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

  <template>
    <div>
      <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
        <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentSubmit">
          <div class="flex flex-wrap items-center email-header justify-between lg:w-full md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
            <div class="flex mb-4">
              <div class="flex items-center">
                <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                <h4 v-if="currentSubmit.title">{{ currentSubmit.title }}</h4>
              </div>
            </div>
            <div class="ml-10 mb-4 mt-1">
              <div class="email__actions--single flex items-baseline">
                <div class="vx-row"  v-if="activeUserLevel == 2 && activeWorkspace.service == true">
                  <vs-button v-if="!submitMember.length && (currentSubmit.state_val == -5 || currentSubmit.state_val >= 0)" svg-classes="h-6 w-6" style="margin-right:10px;" class="plus" color="primary" type="border" icon="icon-file-plus" icon-pack="feather" @click="submitMemberItem()" >제출하기</vs-button>
                </div>
                <feather-icon icon="EditIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeUserLevel >= 3 && activeWorkspace.service == true" @click="editSubmit()"></feather-icon>
                <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeUserLevel >= 3 && activeWorkspace.service == true" @click="deleteSubmit()"></feather-icon>
                <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
                <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" />
              </div>
            </div>
          </div>
          <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-card v-bind:class="vxCardObject" style="margin-top:10px; margin-bottom:10px;">
                  <h4 v-if="currentSubmit.state_val == -1"  class="text-white">[커밍순] {{ startTime | onlydate(true) }} ~ {{endTime  | onlydate(true)}} </h4>
                  <h4 v-if="currentSubmit.state_val == -2"  class="text-white">[마감] {{ startTime | onlydate(true) }} ~ {{endTime  | onlydate(true)}} </h4>
                  <h4 v-if="currentSubmit.state_val >= 0" class="text-white">제출 일정 : {{ startTime | onlydate(true) }} ~ {{endTime  | onlydate(true)}} </h4>
                  <h4 v-if="currentSubmit.state_val == -5" class="text-white">제출 기한 없음</h4>
                </vx-card>
              </div>
            </div>
            <div v-if="isSidebarActive">
              <!-- LATEST MESSAGE -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-card class="px-4">
                    <div class="vx-row">
                      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                        <div class="flex items-center">
                          <div class="flex flex-col">
                            <h5 class="mb-1">{{ currentSubmit.name }}</h5>
                          </div>
                        </div>
                        <div class="flex flex-col justify-end">
                          <span class="text-right">{{ currentSubmit.update_time | time }}</span>
                          <div class="flex justify-end mt-2">
                            <span class="text-right">{{ currentSubmit.update_time | date(true) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="output ql-snow">
                        <div class="ql-editor" v-html="currentSubmit.detail"></div>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
              <div class="vx-row" style="margin-top: 2.2rem">
                <div class="vx-col w-full"  v-for="(item, index) in submitFileList" v-bind:key="index" style="margin-bottom:10px;">
                  <vx-card>
                    <div class="vx-row">
                      <div class="vx-col w-full flex justify-between">
                        <span class="text-lg">{{item}} </span>
                        <feather-icon v-if="activeUserLevel >= 2" svg-classes="h-6 w-6" class="cursor-pointer ml-4" icon="DownloadIcon" @click="fileDonwload(item)"></feather-icon>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-card class="px-4" style="margin-top:10px;">
                    <div id="data-list-list-view" class="data-list-container">
                      <vs-table ref="table"  pagination  :data="submitMember">
                        <div slot="header" class="vx-row w-full text-center">
                          <h4 style="margin-top:5px;"> 제출 리스트 </h4>
                          <vx-tooltip text="전체 다운로드" position="top">
                            <vs-button v-if="activeUserLevel >=3 && currentSubmit.state_val == -2" @click="downloadAllFile()" color="primary" icon="icon-download" icon-pack="feather" type="border" size="small" style="margin-left:10px; margin-bottom:10px; margin-top:2px;"/>
                          </vx-tooltip>
                        </div>
                        <template slot="thead">
                          <vs-th sort-key="name">이름</vs-th>
                          <vs-th sort-key="popularity">제출파일</vs-th>
                          <vs-th sort-key="category">제출일</vs-th>
                          <vs-th sort-key="category">성적</vs-th>
                          <vs-th></vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <tbody>
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td>
                                <p class="product-name font-medium truncate">{{ tr.name }}</p>
                              </vs-td>
                              <vs-td>
                                <vx-tooltip :text="tr.file_name" position="top">
                                  <vs-button class="product-price" type="flat" style="width:200px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; display:inline-block; padding-left:12px; padding-right:12px;" @click="downloadFile(tr)">{{ tr.file_name }}</vs-button>
                                </vx-tooltip>
                              </vs-td>
                              <vs-td>
                                <div class="flex mt-2" style="width:100px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; display:inline-block">
                                  <p class="product-category">{{ tr.update_time | onlydate(true) }}</p> &nbsp;
                                  <div class="flex flex-row">
                                    <p class="text-right">{{ tr.update_time | time(true) }}</p>
                                  </div>
                                </div>
                              </vs-td>
                              <vs-td>
                                <p @click="score(tr)">{{tr.score}}</p>
                              </vs-td>
                              <vs-td class="whitespace-no-wrap">
                                <feather-icon v-if="activeUserLevel >= 3 && (currentSubmit.state_val == -5 || currentSubmit.state_val >= 0) && activeWorkspace.service == true" icon="CheckIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="editScore(tr)"/>
                                <!-- TODO 추후 수정 필요.
                                <feather-icon v-if="activeUserLevel < 3" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="editSubmitMemeberData(tr)"/> -->
                                <feather-icon v-if="activeUserLevel == 2 && (currentSubmit.state_val == -5 || currentSubmit.state_val >= 0) && activeWorkspace.service == true" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="deleteSubmitData(tr.id)"/>
                                <!-- <feather-icon v-if="activeUserLevel == 2 && (currentSubmit.state_val == -5 || currentSubmit.state_val >= 0) && activeWorkspace.service == true" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="score(tr.id)"/> -->
                              </vs-td>
                            </vs-tr>
                          </tbody>
                        </template>
                      </vs-table>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
          </component>
        </div>
      </vs-sidebar>
      <vs-prompt
      class="email-compose"
      title="결과물 공지 수정"
      @cancel="clearFields"
      @accept="updateSubmit"
      @close="clearFields"
      accept-text="제출"
      cancel-text="취소"
      :active.sync="activePrompt2">
        <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
          <form @submit.prevent>
            <div class="mt-4" v-if="shareClass.length > 0">
              <!-- <label class="text-sm">수업 동기화</label> -->
              <v-select placeholder="동기화 수업 없음" v-model="languages_known" multiple :closeOnSelect="false" :options="shareClass" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <!-- <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span> -->
            </div>
              <vs-input name="title" label-placeholder="제목" v-model="title" class="w-full mb-6" />
              <div class="mb-6">
                <flat-pickr :config="configFromdateTimePicker" v-model="fromDate" placeholder="시작일" @on-change="onFromChange" style="margin-right:10px; margin-bottom:5px;"/>
                <flat-pickr :config="configTodateTimePicker" v-model="toDate" placeholder="종료일" @on-change="onToChange"/>
              </div>
              <quill-editor v-model="message" :options="editorOption" />
              <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
                <div class="w-full" v-for="(item, index) in newFileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
                  <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                    <div class="vx-card__collapsible-content" style="text-align:center;">
                      <div class="vx-row" style="margin:5px; ">
                        <div  style="width: 90%;">
                          <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                            {{item.name}}
                          </div>
                        </div>
                        <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                          <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles(index)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
                <div class="w-full" v-for="(item, index) in submitFileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
                  <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                    <div class="vx-card__collapsible-content" style="text-align:center;">
                      <div class="vx-row" style="margin:5px; ">
                        <div  style="width: 90%;">
                          <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">{{item}}</div>
                        </div>
                        <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                          <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deleteFileSubimt(item)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filebox" style="margin-top:30px;">
                <label for="inputFile">첨부 파일</label>
                <input type="file" @change="updateFile2" id="inputFile"  name="inputFile" multiple>
              </div>
            </form>
          </form>
        </component>
      </vs-prompt>
      <vs-prompt
      class="email-compose"
      title="제출하기"
      @cancel="clearFields"
      @accept="acceptFileUpload"
      @close="clearFields"
      accept-text="제출"
      cancel-text="취소"
      :active.sync="activePrompt">
        <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
         <form @submit.prevent>
          <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">결과물을 첨부하세요:)</label>
          <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
            <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
              <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                <div class="vx-card__collapsible-content" style="text-align:center;">
                  <div class="vx-row" style="margin:5px; ">
                    <div  style="width: 90%;">
                      <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                      <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles()"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filebox" style="margin-top:30px;">
            <label for="inputFile">첨부 파일</label>
            <input type="file" @change="updateFile" id="inputFile"  name="inputFile" multiple>
          </div>
        </form>
        </component>
      </vs-prompt>
      <vs-prompt
      class="email-compose"
      title="다시 제출하기"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="acceptEditFile"
      :active.sync="activeEditPrompt">
        <component :is="scrollbarTag" class="scoll_area p-2" :settings="settings" :key="$vs.rtl">
         <form @submit.prevent>
          <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">기존에 있던 파일을 덮어쓰면 복구가 불가능합니다.</label>
          <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-right:2px; padding:3px;">
            <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
              <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                <div class="vx-card__collapsible-content" style="text-align:center;">
                  <div class="vx-row" style="margin:5px; ">
                    <div  style="width: 90%;">
                      <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                      <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles()"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filebox" style="margin-top:30px;">
            <label for="inputFile">첨부 파일</label>
            <input type="file" @change="updateFile" id="inputFile"  name="inputFile" multiple>
          </div>
        </form>
        </component>
      </vs-prompt>
      <vs-prompt
      class="email-compose"
      title="파일 업로드 진행중"
      :buttons-hidden="true"
      :active.sync="activeUploadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-2" :settings="settings" :key="$vs.rtl">
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
            <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
              <div class="vx-card__collapsible-content" style="text-align:center;">
                <div class="vx-row" style="margin:5px; ">
                  <div  style="width: 90%;">
                    <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                      {{item.name}}
                    </div>
                  </div>
                  <vs-progress indeterminate color="primary"></vs-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </component>
    </vs-prompt>
    <vs-prompt
    title="파일 다운로드"
    :buttons-hidden="true"
    :active.sync="downloadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 압축중 - 조금만 기다려주세요 :)</label>
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </component>
    </vs-prompt>

    <vs-popup
    title="성적"
    accept-text="확인"
    @cancel="scoreVal=''"
    @close="scoreVal=''"
    :active.sync="scoreUp">
      <div class="con-exemple-prompt">
        <!-- <vs-input :value="scoreVal" class="mt-3 w-full" /></br> -->
        <span>성적</span>
        <vs-input :value="scoreInfo.score" class="mt-3 w-full" disabled/></br>
        <span>comment</span>
        <vs-textarea :value="scoreInfo.comment" vs-placeholder="코멘트" class="mt-3 w-full" disabled/>
      </div>
    </vs-popup>

    <vs-prompt
    title="성적 입력"
    accept-text="업로드"
    cancel-text="취소"
    @cancel="scoreVal=''; comment=''"
    @accept="updateScore"
    @close="scoreVal=''; comment=''"
    :active.sync="scorePrompt">
      <div class="con-exemple-prompt">
        <p class="text"><strong> {{scoreInfo.name}}</strong> 성적을 입력해주세요.</p>
        <!-- <vs-input placeholder="예: A" vs-placeholder="성적 입력" v-model="scoreVal" class="mt-3 w-full" /></br> -->
        <vs-input  v-model="scoreVal" placeholder="예: A" vs-placeholder="성적 입력" class="mt-3 w-full" /></br>
        <span>comment</span>
        <vs-textarea  v-model="comment" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <vs-prompt
    title="파일 업로드중"
    :buttons-hidden="true"
    :active.sync="uploadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <label style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 업로드중 - 조금만 기다려주세요 :)</label>
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </component>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SubmitCard from "@/views/apps/space/dashboard/submit/SubmitCard.vue"
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  props: {
    openSubmitId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      languages_known:'',
      comment                 : '',
      scorescore              : '',
      startTime               : null,
      endTime                 : null,
      sidebarData             : {},
      activePrompt2           : false,
      showThread              : false,
      activePrompt            : false,
      activeEditPrompt        : false,
      message                 : '',
      title                   : '',
      fileList                : [],
      newFile                 : '',
      submitInfo              : '',
      progress                : false,
      fileName                : '',
      value1                  : '',
      selelctSubmitMemeberInfo: '',
      scorePrompt             : false,
      scoreUp                 : false,
      scoreVal                : '',
      fromDate                : null,
      toDate                  : null,
      activeUploadPrompt      : false,
      scoreInfo               : '',
      downloadPrompt          : false,
      vxCardObject            : 'bg-success px-4',
      deleteFileName          : '',
      newFileList             : [],
      submitFileList          : [],
      uploadPrompt            : false,
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'font': [] }],
          ],
        },
        placeholder: '공지사항 내용을 입력해 주세요 :)'
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    openSubmitId() {
      this.$vs.loading()
        if(this.currentSubmit && this.currentSubmit.file_names){
          this.submitFileList = this.currentSubmit.file_names
        } else {
          this.submitFileList = []
        }
        this.startTime = this.currentSubmit.start_time
        this.endTime = this.currentSubmit.end_time
        if(this.currentSubmit.state_val == -1){
          this.vxCardObject = 'bg-dark px-4'
        }
        else if (this.currentSubmit.state_val == -2){
         this.vxCardObject = 'bg-danger px-4'
        }
        else if (this.currentSubmit.state_val == 0){
         this.vxCardObject = 'bg-warning px-4'
        }
        else if (this.currentSubmit.state_val == -5){
         this.vxCardObject = 'bg-primary px-4'
        }
        else {
         this.vxCardObject = 'bg-success px-4'
        }
        this.$store.dispatch("submit/getSubmitMember",this.openSubmitId).then(()=>{
          this.$vs.loading.close()
        }).catch(() => {
         this.$vs.loading.close()
           this.$vs.notify({
             color: 'danger',
             title: '에러',
             text: '서버 에러 관리자에게 문의해주세요'
           })
        })
      }
    },
    computed: {
      shareClass() {
        return this.$store.state.space.shareClass
      },
      currentSubmit() {
        return this.$store.getters['submit/getSubmit'](this.openSubmitId)
      },
      activeUserLevel() {
        return this.$store.state.space.ActiveDashBoardLevel
      },
      scrollbarTag() { return this.$store.getters.scrollbarTag },
      products() {
        return this.$store.state.dataList.products
      },
      submitMember() {
        return this.$store.state.submit.submitMembers
      },
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      activeWorkspace() {
        return this.$store.state.space.ActiveSpaceInfo
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      },
    },
    created() {
    },
    methods: {
      deletefiles2(index){
        this.newFileList.splice(index,1)
      },
      fileDonwload(item){
        this.$store.dispatch('submit/submitFileDonwload', {'param':'id='+this.openSubmitId+'&'+'name='+item, 'name': item}).then(() => {
        })
      },
      downloadAllFile(){
        if(this.submitMember.length == 0){
          this.$vs.notify({
            color: 'danger',
            title: '파일 없음.',
            text: '제출된 파일이 없습니다'
          })
          return
        }
        this.downloadPrompt= true
        this.$store.dispatch("submit/fileCompressSubmitMembe", {id:this.openSubmitId, file_name: this.currentSubmit.title+'.zip'})
        .then(()=>{
          this.$store.dispatch("submit/fileDonwloadSubmitMembe", {'param':'submit_id='+this.openSubmitId+'&'+'id=all', 'name': this.currentSubmit.title+'.zip'})
          this.downloadPrompt= false
          this.$vs.notify({
          color:'success',
          title:'압축 완료'
          })
        }).catch(() => {
          this.downloadPrompt= false
          this.$vs.notify({
          color: 'danger',
          title:'실패',
          text:'관리자에게 문의 하세요'
          })
        })
      },
      score(info){
        this.scoreInfo = info
        this.scoreUp = true
      },
      editScore(info){
        this.scoreInfo = info
        this.scorePrompt = true
      },
      updateScore(){
        this.$store.dispatch("submit/updateSubmitMemberScore", {workspace_id:this.activeWorkspace.id, id:this.scoreInfo.id, score:this.scoreVal, comment:this.comment}).then(()=>{
          this.$vs.notify({
          color:'success',
          title:'성적 업로드 완료',
          text:'성적을 업로드 하였습니다'
          })
        }).catch(() => {
          this.$vs.notify({
          color: 'danger',
          title:'실패',
          text:'관리자에게 문의 하세요'
          })
        })
      },
      onFromChange(selectedDates, dateStr) {
        this.$set(this.configTodateTimePicker, 'minDate', dateStr)
      },
      onToChange(selectedDates, dateStr) {
        this.$set(this.configFromdateTimePicker, 'maxDate', dateStr)
      },
      downloadFile(val){
        this.submitInfo = val
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `파일 저장`,
          text: '해당 파일을 저장하시겠습니까?',
          accept: this.acceptDownload
        })
      },
      acceptDownload(){
        this.$store.dispatch("submit/fileDonwloadSubmitMembe", {'param':'submit_id='+this.submitInfo.submit_id+'&'+'id='+this.submitInfo.id, 'name': this.submitInfo.file_name})
      },
      deletefiles(){
        this.fileList = []
      },
      submitMemberItem(){
        this.fileList = []
        this.activePrompt = true
      },
      updateFile(){
        var file = document.getElementById("inputFile").files[0]
        if (file.size > this.$store.state.uploadFileMaxSize) {
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '첨부파일 용량은 15M까지 사용가능합니다'
          })
          return
        }
        this.newFile = ''
        this.fileList = []
        this.fileList.push(file)
        this.newFile = file
      },
      updateFile2(){
        var size = 0
        if(this.currentSubmit.file_size){
          size = this.currentSubmit.file_size
        }
        var samefile = false
        for(var index = 0; index < document.getElementById("inputFile").files.length; index++) {
          var file = document.getElementById("inputFile").files[index]
          size = size + file.size
          if (size > this.$store.state.uploadFileMaxSize) {
            this.$vs.notify({
              color: 'danger',
              title: '에러',
              text: '첨부파일 용량은 15M까지 사용가능합니다'
            })
            break
          }
          if (this.submitFileList.findIndex(function(item){return item == file.name}) == -1 &&
          this.newFileList.findIndex(function(item){return item.name == file.name}) == -1) {
            this.newFileList.push(file)
          }else {
            samefile = true
          }
        }
        if (samefile){
          this.$vs.notify({
            color:'danger',
            title:'중복파일',
            text:'같은 이름이 있습니다 확인해주세요'
          })
        }
      },
      close(){
        this.$vs.notify({
          color:'danger',
          title:'닫기',
          text:'저장하지 않고 닫았습니다'
        })
      },
      acceptFileUpload(){
        if(this.fileList.length != 1){
          this.$vs.notify({color:'danger',title:'첨부파일 에러',text:'첨부파일을 다시 확인해주세요'})
          return
        }
        this.uploadPrompt = true
        this.$store.dispatch("submit/createSubmitMember", {id:this.openSubmitId, title:'', detail:'', file:this.fileList[0], workspace_id:this.activeWorkspace.id}).then(()=>{
          this.uploadPrompt = false
          this.$vs.notify({color:'success',title:'제출 완료',text:'결과물 제출을 완료하였습니다'})
        }).catch(() => {
          this.uploadPrompt = false
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '제출 날짜를 확인해 주세요'
          })
        })
      },
      editSubmit() {
        this.title = this.currentSubmit.title
        this.message = this.currentSubmit.detail
        this.fromDate = this.currentSubmit.start_time
        this.toDate = this.currentSubmit.end_time
        this.fileList = []
        this.newFileList = []
        if(this.currentSubmit.file_name){
          this.fileList.push({name:this.currentSubmit.file_name})
        }
        this.activePrompt2 = true
      },
      clearFields() {
        this.$nextTick(() => {
          this.title = ''
          this.message = ''
          this.fileList = []
          this.newFileList = []
        })
      },
      moveTo(to) {
        this.$emit('closeSidebar')
        this.$emit('moveTo', to)
      },
      deleteSubmit() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `공지사항 삭제`,
          text: '모든 첨부/제출 파일 및 공지사항을 삭제하시겠습니까?',
          accept: this.acceptDelete
        })
      },
      acceptDelete() {
        this.$store.dispatch('submit/deleteSubmit', this.openSubmitId)
        .then(()=>{
          this.$emit('closeSidebar')
          this.$vs.notify({
            color: 'success',
            title: '삭제 완료',
            text: '선택된 글이 삭제되었습니다.'
          })
        })
      },
      updateSubmit() {
        this.uploadPrompt = true
        var shareClass = []
        for (var i in this.languages_known){
          shareClass.push(this.languages_known[i].value)
        }
        this.$store.dispatch('submit/updateSubmit', {param:{id:this.openSubmitId, title:this.title, detail:this.message, workspace_id:this.activeWorkspace.id,
          start:this.fromDate, end:this.toDate, size:this.newFileList.length, "share_class":shareClass}, files:this.newFileList})
        .then((resolve)=>{
          //TODO 코드 로직 수정 필요.
          var t1 = this.$moment(new Date()).format('YYYYMMDD')
          var index = this.$store.state.submit.submits.findIndex(function(item){return item.id == resolve.data.data.id})
          this.setDateState(index, resolve.data.data, t1)

          if(this.currentSubmit && this.currentSubmit.file_names){
            this.fileList = this.currentSubmit.file_names
          }
          this.uploadPrompt = false
          this.$vs.notify({
            color: 'success',
            title: '수정 완료'
          })
        }).catch(() => {
          this.uploadPrompt = false
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '관리자에게 문의해 주세요.'
          })
        })
      },
      editSubmitMemeberData(data) {
        this.newFile = ''
        this.fileList = []
        this.selelctSubmitMemeberInfo = data
        this.fileList.push({name:data.file_name})
        this.activeEditPrompt = true
      },
      deleteFileSubmit(name){
        this.deleteFileName = name
        this.acceptFileDelete()
      },
      acceptFileDelete(){
        this.$store.dispatch('submit/deleteSubmitFile','id='+this.openNoticeId+'&'+'name='+this.deleteFileName).then(()=>{
          if(this.currentSubmit && this.currentSubmit.file_names){
            this.submitFileList = this.currentSubmit.file_names
          } else {
            this.submitFileList = []
          }
          this.$vs.notify({
            color: 'danger',
            title: '삭제 완료',
            text: '선택된 파일이 삭제되었습니다.'
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '삭제 실패',
            text: '선택된 파일이 없습니다.'
          })
        })
      },
      acceptEditFile() {
        if(this.newFile){
          this.uploadPrompt = true
          this.$store.dispatch('submit/updateSubmitMember', {id:this.selelctSubmitMemeberInfo.id, title:'', detail:'', file:this.newFile}).then(()=>{
            this.uploadPrompt = false
            this.$vs.notify({color:'success',title:'수정 완료',text:'결과물 수정을 완료하였습니다.'})
          }).catch(() => {
            this.uploadPrompt = false
            this.$vs.notify({
              color: 'danger',
              title: '에러',
              text: '제출 날짜를 확인해 주세요.'
            })
          })
        }
      },
      deleteSubmitData(id) {
        this.$store.dispatch('submit/deleteSubmitMember', id).then(()=> {
          this.$vs.notify({
            color:'danger',
            title:'결과물 삭제 완료',
            text:'제출했던 결과물을 삭제하였습니다.'
          })
        })
      },
      setDateState(itemIndex, submitInfo, t1){
        var start_time = this.$moment(submitInfo.start_time).format('YYYYMMDD') - t1
        var end_time = this.$moment(submitInfo.end_time).format('YYYYMMDD') - t1
        this.startTime = submitInfo.start_time
        this.endTime = submitInfo.end_time
        if (submitInfo.start_time && start_time > 0){
          this.vxCardObject = 'bg-dark px-4'
          this.$store.commit('submit/SET_SUBMIT_DATE_UPDATE', {index:itemIndex, val:-1})
        }
        else if(!submitInfo.start_time && !submitInfo.end_time){
          this.vxCardObject = 'bg-primary px-4'
          this.$store.commit('submit/SET_SUBMIT_DATE_UPDATE', {index:itemIndex, val:-5})
        }
        else if (!submitInfo.end_time){
         this.vxCardObject = 'bg-primary px-4'
          this.$store.commit('submit/SET_SUBMIT_DATE_UPDATE', {index:itemIndex, val:-5})
        }
        else if(end_time < 0){
          this.$store.commit('submit/SET_SUBMIT_DATE_UPDATE', {index:itemIndex, val:-2})
          this.vxCardObject = 'bg-danger px-4'
        }
        else if(end_time == 0){
          this.$store.commit('submit/SET_SUBMIT_DATE_UPDATE', {index:itemIndex, val:0})
          this.vxCardObject = 'bg-warning px-4'
        }
        else{
          this.$store.commit('submit/SET_SUBMIT_DATE_UPDATE', {index:itemIndex, val:end_time})
          this.vxCardObject = 'bg-success px-4'
        }
      }
    },
    components: {
      quillEditor,
      VuePerfectScrollbar,
      'submitCard': SubmitCard,
      flatPickr,
      vSelect
    }
}

</script>

<style lang="scss">
.text {
    font-size: 16px;
    max-width: 400px;
    line-height: 1.5;
}
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
